import axiosInstance from "../service/axiosInterceptor";

/**
 * Fetch all billers
 */
export async function getAllBiller() {
  try {
    const response = await axiosInstance.get(`/user/billers`);
    console.log("response.data", response.data);
    return response.data; // Return the data from the API response
  } catch (error) {
    throw error;
  }
}

/**
 * Delete a biller by ID
 * @param {string} employeeId - The ID of the biller to delete
 */
export async function deleteBillerById(employeeId) {
  try {
    const response = await axiosInstance.put(`/user/deactivate/${employeeId}`);
    return response.data; // Return the data from the API response
  } catch (error) {
    throw error;
  }
}

/**
 * Fetch a biller by ID
 * @param {string} billerId - The ID of the biller to fetch
 */
export async function getAllBillerById(billerId) {
  try {
    const response = await axiosInstance.get(`/user/${billerId}`);
    return response.data; // Return the data from the API response
  } catch (error) {
    throw error;
  }
}

/**
 * Create a new biller
 * @param {Object} employeeData - The data for the new biller
 */
export const createBiller = async (employeeData) => {
  try {
    const response = await axiosInstance.post(`/auth/signup`, employeeData);
    return response.data; // Return the response data
  } catch (error) {
    throw error;
  }
};

/**
 * Update a biller's details
 * @param {string} id - The ID of the biller to update
 * @param {Object} updatedData - The updated data for the biller
 */
export const updateBiller = async (id, updatedData) => {
  try {
    const response = await axiosInstance.put(`/user/${id}`, updatedData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Fetch completed jobs for a specific biller
 * @param {string} id - The ID of the biller
 */
export const getCompletedJobs = async (id) => {
  try {
    const response = await axiosInstance.get(`/job/biller/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};